import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../../services/storage.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {

  const storageService = inject(StorageService);
  
  if (storageService.apiKey) {
    req = req.clone({
      setHeaders: {
        ['X-API-Key']: `${storageService.apiKey}`,
      },
    });
  }
  
  return next(req);
};
